import {
  DetalleTransporteDeFecha,
  SalidaTransporteDeFecha,
} from "../../../services/transporteServicios";
import { ListGroupItem } from "react-bootstrap";
import VisibilityIcon from "@mui/icons-material/Visibility";
import IconContainer from "../../organisms/IconContainer";

import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

import EditIcon from "@mui/icons-material/Edit";
import { ModificacionesDetalle } from "./Modificaciones";

function SalidaItem({
  salida,
  onDetalleClick,
  onChequearSalida,
  modificacionesSalida,
  onSubirOrden,
  esPrimero,
  anterior,
  siguiente,
  onBajarOrden,
  esUltimo,
}: {
  salida: SalidaTransporteDeFecha;
  onDetalleClick: (detalle: DetalleTransporteDeFecha) => void;
  onChequearSalida: (
    salida: SalidaTransporteDeFecha,
    transportado: boolean
  ) => void;
  onSubirOrden: (
    salida: SalidaTransporteDeFecha,
    anterior: SalidaTransporteDeFecha
  ) => void;
  onBajarOrden: (
    salida: SalidaTransporteDeFecha,
    siguiente: SalidaTransporteDeFecha
  ) => void;
  modificacionesSalida: ModificacionesDetalle | undefined;
  esPrimero: boolean;
  esUltimo: boolean;
  anterior: SalidaTransporteDeFecha | undefined;
  siguiente: SalidaTransporteDeFecha | undefined;
}) {
  const onDetalleViewEditClick = () => {
    onDetalleClick(salida);
  };

  const transportado =
    modificacionesSalida && modificacionesSalida.transportado !== undefined
      ? modificacionesSalida.transportado
      : salida.transportado;

  return (
    <ListGroupItem
      as="li"
      className={`d-flex mt-2 p-1 border rounded ${
        transportado ? "border-success" : ""
      }`}
    >
      <div className="ps-2 row" style={{ paddingRight: 0, marginRight: 0, width: '100%' }}>
        <div className="row" style={{ paddingRight: 0, marginRight: 0, width: '100%' }}>
          <div className="col-7">
            <strong>{salida.mascota.nombre}</strong>
          </div>
          <div className="col-5" style={{ paddingRight: 0, marginRight: 0 }}>
            <div
              className="d-flex justify-content-end"
              style={{ paddingRight: 0 }}
            >
              {!esPrimero && (
                <div className="d-flex ps-2">
                  <IconContainer
                    onClick={() => {
                      onSubirOrden(salida, anterior!);
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <ArrowUpwardIcon />
                  </IconContainer>
                </div>
              )}

              {!esUltimo && (
                <div className="d-flex ps-2">
                  <IconContainer
                    onClick={() => {
                      onBajarOrden(salida, siguiente!);
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <ArrowDownwardIcon />
                  </IconContainer>
                </div>
              )}
              <div className="d-flex ps-2">
                <IconContainer
                  onClick={onDetalleViewEditClick}
                  style={{ cursor: "pointer" }}
                >
                  {transportado ? <VisibilityIcon /> : <EditIcon />}
                </IconContainer>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <small>{salida.hora}</small>
        </div>
        <div className="row">
          <small>
            {salida.direccion} - {salida.sector.nombre}
          </small>
        </div>
      </div>
    </ListGroupItem>
  );
}

export default SalidaItem;
